import { AnalyticsAction } from './models/AnalyticsAction';
import {
  IAnalyticsContext,
  IAnalyticsProvider,
} from './providers/AnalyticsProvider';
import { MixpanelProvider } from './providers/MixpanelProvider';
import { MockAnalyticsProvider } from './providers/MockAnalyticsProvider';

export class Analytics {
  provider: IAnalyticsProvider;

  constructor(provider: IAnalyticsProvider) {
    this.provider = provider;
  }

  /** track event and send to Primer. */
  call(action: AnalyticsAction): boolean | void {
    return this.provider.call(action);
  }

  /** start timing event that might happen in the future. */
  time(action: AnalyticsAction): boolean | void {
    return this.provider.time(action);
  }

  /** updates analytics about the context the checkout is in. */
  setContext(context: IAnalyticsContext): void {
    this.provider.setContext(context);
  }

  /** updates analytics about which environment the SDK is running in. */
  setSdkEnvironment(env: string): void {
    this.provider.setSdkEnvironment(env);
  }

  /** updates analytics about what payment method the user selected. */
  setPaymentIntent(intent: string): void {
    this.provider.setPaymentIntent(intent);
  }
}

export function createAnalytics(url?: string): Analytics {
  const provider = url
    ? new MixpanelProvider(url)
    : new MockAnalyticsProvider();

  return new Analytics(provider);
}
